export class PaginationOptions {
	pageIndex: number;
	pageSize: number;
	sort?: {
		key: string;
		value: string;
	};
	search?: string;
	filters?: {
		key: string;
		value: string[] | number[] | boolean;
	}[];

	constructor(pageIndex?: number, pageSize?: number) {
		if (pageIndex && pageSize) {
			this.pageIndex = pageIndex;
			this.pageSize = pageSize;
		} else {
			this.pageIndex = 1;
			this.pageSize = 10;
		}
	}
}
